module.exports = __webpack_public_path__ + "img/float_role.b19c445.png";